import { InjectionToken } from '@angular/core';

/** Handle to a rendered toast — the slice of `growl.IGrowlMessage` we use. */
export interface GrowlMessageHandle {
  destroy(): void;
}

/** Per-message config — the slice of `growl.IGrowlMessageConfig` we use. */
export interface GrowlMessageConfig {
  ttl?: number;
}

/**
 * Minimal contract for the AngularJS `growl` service (angular-growl-v2) — only
 * the surface NotificationService consumes. Declaring it locally (rather than
 * importing the `growl` namespace from `angular`) keeps the growl typings out
 * of this app's compilation and makes the backend trivially swappable.
 */
export interface GrowlService {
  success(message: string, config?: GrowlMessageConfig): GrowlMessageHandle;
}

/**
 * Bridge to the AngularJS `growl` service.
 *
 * NotificationService is a thin, backend-agnostic wrapper over `growl`. The
 * `growl` service is AngularJS-only (provided by the `angular-growl` module)
 * with no Angular 18 equivalent in this hybrid app, so it is reached through
 * this port.
 *
 * The port is an implementation detail: the growl backend is expected to be
 * swapped for a native toast (or `ngx-toastr`) later by changing only
 * NotificationService — no caller references `growl` or this token directly.
 */
export const GROWL_PORT = new InjectionToken<GrowlService>('GROWL_PORT');
